import { useFanes } from '../../fanes';
import { TitleProps, TitleToken } from '../concepts/title';

export const Title: React.FC<TitleProps> = props => {
  const Comp = useFanes(s => s.use<TitleProps>(TitleToken));
  return <Comp {...props} />;
};
